<div class="col-12 p-0" *ngIf="lists">
    <button type="button" class="btn enquire" onclick="openHomeEnquiry();">
        <span class="material-icons-outlined">
            help_outline
        </span>
        <span class="d-block text-uppercase w-100 mt-3 text">
            <!-- enquiry -->
            {{ "SITETEXT.ENQ" | translate }}
        </span>
    </button>
    <div class="shader">
        <div class="carousel-caption text-left">
            <!-- <div class="header-title-body" [innerHtml]="bannertext"></div> -->
            <div class="font-44 mb-4" [innerHtml]="bannertext"></div>
            <div class="font-18 carousel-caption__info d-none d-md-block" [innerHtml]="bannerDesc"></div>
            <div class="col-12 p-0 d-flex">
                <!-- <div class="col-auto pl-0">
                    <button type="button" class="btn btn-primary bold text-uppercase" (click)="gotoExplore()">book
                        now</button>
                </div> -->
                <!-- <div class="col-auto p-0">
                    <button  type="button" class="btn btn-primary white-stroked bold text-uppercase" (click)="gotoExplore()">explore</button>
                </div> -->
            </div>
        </div>

        <div class="col-sm-12 col-md-10 offset-md-2 p-0">
            <div id="" class="carousel-home">
                <div *ngFor="let list of lists">
                    <img [src]="list.url" class="d-block w-100"  alt="...">
                </div>
                <!-- <div> <img
                        src="https://images.pexels.com/photos/774282/pexels-photo-774282.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                        class="d-block w-100" alt="..." style="height: 630px;"></div>
                <div> <img
                        src="https://images.pexels.com/photos/343419/pexels-photo-343419.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                        class="d-block w-100" alt="..." style="height: 630px;"></div>
                <div>
                    <img src="https://images.pexels.com/photos/672630/pexels-photo-672630.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"
                        class="d-block w-100" alt="..." style="height: 630px;">
                </div> -->
            </div>

            <!-- <div class="col-md-8 pl-0">
                <app-search-home [(ngModel)]="searchString" (ngModelChange)="changeSearchValue($event)">
                </app-search-home>
            </div> -->
        </div>


    </div>
</div>
